// O que as quatro telas da Base repetiam.
//
// Não é abstração por gosto: `hora`, `dataHora` e `irPara` estavam copiados em cinco arquivos, e
// a correção do "11h31" (hora com h, como no resto da interface) precisou ser feita em um só
// deles, o que deixou os outros quatro mostrando 11:31. Regra de formatação repetida é regra que
// diverge na primeira correção.
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

// O chip de estado, na mesma cor em toda a feature: a pessoa aprende a cor uma vez.
export const CHIP_ESTADO = {
  no_ar: 'bg-n-alpha-2 text-n-slate-11',
  alterado: 'bg-n-amber-3 text-n-amber-11',
  novo: 'bg-n-teal-3 text-n-teal-11',
  a_sair: 'bg-n-ruby-3 text-n-ruby-11',
};

export const CHIP_TIPO = {
  publicacao: 'bg-n-alpha-2 text-n-slate-11',
  importacao: 'bg-n-blue-3 text-n-blue-11',
  reversao: 'bg-n-ruby-3 text-n-ruby-11',
};

export const MONO =
  'font-mono text-[10px] tracking-[.06em] px-1.5 py-0.5 rounded-sm';

export const useBase = () => {
  const router = useRouter();
  const { accountId } = useAccount();

  const irPara = (name, params = {}, query = undefined) =>
    router.push({
      name,
      params: { accountId: accountId.value, ...params },
      ...(query ? { query } : {}),
    });

  return { irPara };
};

const vazio = valor => valor === null || valor === undefined || valor === '';

// 11h31, com "h", que é como a hora aparece no resto da interface do clube.
export const hora = valor =>
  vazio(valor)
    ? ''
    : new Date(valor)
        .toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
        .replace(':', 'h');

export const data = valor =>
  vazio(valor)
    ? ''
    : new Date(valor).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      });

export const dataHora = valor =>
  vazio(valor) ? '' : `${data(valor)} ${hora(valor)}`;
